export const AVITO_PROPERTY_RIGHTS = Object.freeze(['Собственник', 'Посредник'])

export function buildAvitoPreviewParams({ classifiedAccountId, propertyRights } = {}) {
	const params = {}
	if (classifiedAccountId !== undefined && classifiedAccountId !== null && classifiedAccountId !== '') {
		params.classifiedAccountId = String(classifiedAccountId)
	}
	if (AVITO_PROPERTY_RIGHTS.includes(propertyRights)) {
		params.propertyRights = propertyRights
	}
	return params
}

export function groupPreviewDiagnostics(diagnostics) {
	if (!Array.isArray(diagnostics)) return []

	const groups = new Map()
	for (const diagnostic of diagnostics) {
		const source =
			diagnostic && typeof diagnostic.source === 'string'
				? diagnostic.source
				: 'preview'
		if (!groups.has(source)) groups.set(source, [])
		groups.get(source).push(diagnostic)
	}

	return [...groups.entries()].map(([source, items]) => ({ source, items }))
}

export function prettyPreviewValue(value, emptyLabel = 'Unavailable') {
	if (value === undefined || value === null) return emptyLabel
	return JSON.stringify(value, null, 2)
}

export function buildCreatedAccountPreviewSelection(account, propertyRights) {
	return {
		classifiedAccountId:
			account?.id === undefined || account?.id === null ? '' : String(account.id),
		propertyRights: AVITO_PROPERTY_RIGHTS.includes(propertyRights)
			? propertyRights
			: '',
	}
}

export function mergePreviewAccountCandidates(candidates, accounts) {
	const merged = new Map()
	for (const candidate of Array.isArray(candidates) ? candidates : []) {
		if (candidate?.classifiedAccountId !== undefined) {
			merged.set(String(candidate.classifiedAccountId), candidate)
		}
	}
	for (const account of Array.isArray(accounts) ? accounts : []) {
		if (account?.id === undefined) continue
		const id = String(account.id)
		if (!merged.has(id)) {
			merged.set(id, {
				listingId: null,
				classifiedAccountId: id,
				accountName: account.name,
				accountStatus: account.status,
				feedId: null,
				desiredState: null,
				includedInFeed: null,
			})
		}
	}
	return [...merged.values()]
}
